import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { motion } from 'framer-motion';
import {
	TUTORIAL_DEMO_ENTRY_BLACK_FADE_MS,
	TUTORIAL_DEMO_ENTRY_BLACK_HOLD_MS,
} from '@/constants/professionalTutorialDemo';
import { unmountTutorialDemoEntryBlackOverlay } from './tutorialDemonstracaoEntryOverlay';

type Props = {
	onComplete?: () => void;
};

/**
 * Cortina preta da entrada na demonstração (fase 2 da abertura estilo Netflix).
 * A página carrega por baixo; esta camada some devagar revelando o lobby.
 */
const TutorialDemonstracaoEntryBlackCurtain = ({ onComplete }: Props) => {
	const totalMs =
		TUTORIAL_DEMO_ENTRY_BLACK_HOLD_MS + TUTORIAL_DEMO_ENTRY_BLACK_FADE_MS;
	const holdEnd = TUTORIAL_DEMO_ENTRY_BLACK_HOLD_MS / totalMs;

	useEffect(() => {
		document.body.style.overflow = 'hidden';
		const timer = window.setTimeout(() => {
			unmountTutorialDemoEntryBlackOverlay();
			onComplete?.();
		}, totalMs);

		return () => {
			window.clearTimeout(timer);
			unmountTutorialDemoEntryBlackOverlay();
		};
	}, [onComplete, totalMs]);

	return createPortal(
		<motion.div
			className="pointer-events-auto fixed inset-0 z-[10055] bg-black"
			data-tutorial-demo-entry-curtain
			aria-hidden
			initial={{ opacity: 1 }}
			animate={{ opacity: [1, 1, 0] }}
			transition={{
				duration: totalMs / 1000,
				times: [0, holdEnd, 1],
				ease: [0.4, 0, 0.2, 1],
			}}
		/>,
		document.body,
	);
};

export { TutorialDemonstracaoEntryBlackCurtain };
